/*

Pixel Field Editor - developed by Satori, s.r.o. (c) 2014-2016 - zden@satori.sk
---------------------------------
Legal notice: Source code is for internal purposes only of developing
and integrating Pixel Field Editor to the larger asset of Forms+Surfaces
online services. Any modifications must be discussed with Satori, s.r.o. and no derivates to other projects are allowed without prior written permission from Satori, s.r.o.
---------------------------------
Satori, s.r.o. | Jegeho 21 | 821 08 Bratislava | +421-903-258-862 | www.satori.sk

*/


var CONTROL_SLIDER = 0;
var CONTROL_COLOR = 1;
var CONTROL_CHECKBOX = 2;
var CONTROL_BUTTON = 3;
var CONTROL_HIDDEN = 4;

var CONTROL_SLIDER_WID = 200;
var CONTROL_SLIDER_HEI = 10;
var ARROW_WIDTH = 6;
var COLOR_BOX_WIDTH = 12;
var CONTROL_BUTTON_HEIGHT = 16;
var CONTROL_BUTTON_HOR_MARGIN = 4;

var CON_FLAG_PROPORTIONAL = 1;

var control_class = 0;

var UI_FONT = "13px Arial";

function _rect(x, y, wid, hei)
{
	this.x = x;
	this.y = y;
	this.wid = wid;
	this.hei = hei;
	this.xs = this.ye = 0;
}

var img_bt_rst_ok = 0;
var ui_refresh = 0;

function control_create(name, display_name, type, min, max, value, col_grad_s, col_grad_e, col_arrow)
{
	this.name = name;
	this.display_name = display_name;
	this.type = type;
	this.value_default = this.value = this.value_orig = value;
	this.value_last_pos = -1;
	this.min = this.min_orig = min;
	this.max = this.max_orig = max;
	this.dist = max - min;
	this.pos_x = this.pos_y = 0;
	if (type != CONTROL_BUTTON)
	{
		this.col_grad_s = col_grad_s;
		this.col_grad_e = col_grad_e;
		this.col_arrow = col_arrow;
	}
	else
	{
		this.image = new Image();
		this.image.src = col_grad_s;
		this.image.onload = function() { img_bt_rst_ok = 1; ui_refresh = 1; };
	}
	this.col_grad_m = 0;
	if (type != CONTROL_HIDDEN)
		this.visible = 1;
	else
		this.visible = 0;
	this.UI_show_values = 1;
	this.flags = 0;
}

function control_area(col_bg, col_con, col_con_fill, col_text)
{
	this.controls = new Array(0);
	this.controls_num = 0;
	this.col_bg = col_bg;
	this.col_con = col_con;
	this.col_con_fill = col_con_fill;
	this.col_text = col_text;
	this.area_wid = this.area_hei = 0;
	this.offset_x = this.offset_y = 0;
	control_class = this;
	this.control_focus = -1;
	this.UI_change = 0;
	this.UI_change_eval = 0;
	this.range_proportion = 1.0;
}

control_area.prototype.show_values = function (mode)
{
	this.UI_show_values = mode;
	if (mode)
		this.paint_update(1);
	else
		this.paint_refresh();
}

control_area.prototype.control_add = function (control)
{
	this.controls.push(control);
	this.controls_num = this.controls.length;
}

control_area.prototype.control_flags = function (name, flags)
{
	var a;

	for (a = 0; a < this.controls_num; a++)
		if (this.controls[a].name == name)
		{
			this.controls[a].flags = flags;
			return;
		}
}

control_area.prototype.color_grad_mid = function (name, col_m)
{
	var a;

	for (a = 0; a < this.controls_num; a++)
		if (this.controls[a].name == name)
		{
			this.controls[a].col_grad_m = col_m;
			return;
		}
}

control_area.prototype.visible = function (name, vis)
{
	var a;

	for (a = 0; a < this.controls_num; a++)
		if (this.controls[a].name == name)
			this.controls[a].visible = vis;
	return (-1);
}

control_area.prototype.range = function (name, min, max)
{
	var a;

	for (a = 0; a < this.controls_num; a++)
		if (this.controls[a].name == name)
		{
			this.controls[a].min_orig = min;
			this.controls[a].max_orig = max;
			this.controls[a].min = min * this.range_proportion;
			this.controls[a].max = max * this.range_proportion;
			this.controls[a].dist = this.controls[a].max - this.controls[a].min;
			this.controls[a].value = this.controls[a].min+(this.controls[a].max-this.controls[a].min)/2;
		}
	return (-1);
}

control_area.prototype.setValue = function (name, col)
{
	var a;

	for (a = 0; a < this.controls_num; a++)
		if (this.controls[a].name == name)
		{
			this.controls[a].value = col;
			break;
		}
}

control_area.prototype.value = function (name)
{
	var a;

	for (a = 0; a < this.controls_num; a++)
		if (this.controls[a].name == name)
		{
			if (this.controls[a].type == CONTROL_COLOR)
				return(this.controls[a].value);	
			else
				return(Math.floor(this.controls[a].value));
		}
	return (-1);
}

control_area.prototype.default = function (name)
{
	var a;

	for (a = 0; a < this.controls_num; a++)
		if (this.controls[a].name == name)
		{
			this.controls[a].value = this.controls[a].value_default;
			break;
		}
	return (-1);
}

control_area.prototype.valuef = function (name)
{
	var a;

	for (a = 0; a < this.controls_num; a++)
		if (this.controls[a].name == name)
			return(this.controls[a].value);
	return (-1);
}

control_area.prototype.value_def = function (name)
{
	var a;

	for (a = 0; a < this.controls_num; a++)
		if (this.controls[a].name == name)
		{
			if (this.controls[a].type == CONTROL_COLOR)
				return(this.controls[a].value_default);	
			else
				return(Math.floor(this.controls[a].value_default));
		}
	return (-1);
}

control_area.prototype.valuef_def = function (name)
{
	var a;

	for (a = 0; a < this.controls_num; a++)
		if (this.controls[a].name == name)
			return(this.controls[a].value_default);
	return (-1);
}

control_area.prototype.eval_val = function (name)
{
	var a;

	for (a = 0; a < this.controls_num; a++)
		if (this.controls[a].name == name)
			this.controls[a].value = this.UI_change_eval(name, this.controls[a].value, this.controls[a].min, this.controls[a].max);
}

control_area.prototype.auto_design = function()
{
	var a;
	var x = 16, y = 30, y_step = 59-5;
	var con;
	var ys;
	var cv = 0;

	for (a = 0; a < this.controls_num; a++)
	{
		if (this.controls[a].visible) cv++;
	}
	if (this.canvas)
	{
		ys = this.canvas.height / cv;
		if (ys < y_step)
			y_step = ys;
	}

	for (a = 0; a < this.controls_num; a++)
	{
		con = this.controls[a];
		if (con.visible)
		{
			con.pos_x = x;
			con.pos_y = y;
			y += y_step;
		}
	}
}

control_area.prototype.mouse_update = function(mouse_x, mouse_y, move)
{
	var a;
	var x, y, w, v;
	var go = 0;

	for (a = 0; a < this.controls_num; a++)
	{
		con = this.controls[a];
		if (!con.visible) continue;
		if (con.type == CONTROL_COLOR) continue;

		x = this.offset_x + con.pos_x;
		y = this.offset_y + con.pos_y;

		switch (con.type)
		{
			case CONTROL_SLIDER:
				if (this.control_focus == -1)
				{
					if (mouse_x >= x && mouse_x <= x + CONTROL_SLIDER_WID && mouse_y >= y - 4 && mouse_y < y + CONTROL_SLIDER_HEI + 8 + 4)
						go = 1;
				}
				else
				if (this.control_focus == a)
				{
					go = 1;
				}
				if (go)
				{
					if (mouse_x < x) mouse_x = x;
					else
					if (mouse_x >= x + CONTROL_SLIDER_WID) mouse_x = x + CONTROL_SLIDER_WID;

					v = con.min + ((mouse_x - x) * con.dist) / CONTROL_SLIDER_WID;
					undo_add(UNDO_ACTION_VALUE, con.name, con.value, 1);
					con.value = v;
					v = this.UI_change_eval(con.name, v, con.min, con.max);
					con.value = con.value_orig = v;
					this.UI_change(con.name, v);
					this.paint_update(0);
					this.control_focus = a;
					return;
				}
				break;

			case CONTROL_CHECKBOX:
				x += 8 + measure_text(this.context, con.display_name, UI_FONT);
				if (mouse_x >= x && mouse_x < x + COLOR_BOX_WIDTH && mouse_y >= y - COLOR_BOX_WIDTH && mouse_y < y)
				{
					undo_add(UNDO_ACTION_VALUE, con.name, con.value, 0);
					if (con.value_default != -1)
						con.value = con.value ? 0 : 1;
					this.UI_change(con.name, v);
					this.paint_update(0);
					return;
				}
				break;

			case CONTROL_BUTTON:
				if (mouse_x >= x && mouse_x < x + con.image.width && mouse_y > y - con.image.height && mouse_y < y)
				{
					this.UI_change(con.name);
					return;
				}
			/*
				w = measure_text(this.context, con.display_name, UI_FONT) + CONTROL_BUTTON_HOR_MARGIN*2;
				if (mouse_x >= x && mouse_x < x + w && mouse_y > y - CONTROL_BUTTON_HEIGHT + 3 && mouse_y < y + 3)
				{
					this.UI_change(con.name);
					return;
				}
			*/
				break;
		}


	}
}

control_area.prototype.mouse_down = function(mx, my)
{
	if (control_class.control_focus == -1)
	{
		control_class.mouse_update(mx, my, 0);
	}
}



control_area.prototype.mouse_up = function(mx, my)
{
	if (control_class.control_focus != -1)
	{
		undo_add(UNDO_ACTION_VALUE_END);
	}

	control_class.control_focus = -1;
}

control_area.prototype.mouse_move = function(mx, my)
{
	if (control_class.control_focus != -1)
		control_class.mouse_update(mx, my, 1);
}

control_area.prototype.mouse = function(event, mx, my, btn, wheel)
{
	pos = getPosition(control_class.canvas);
	mx -= pos.x;
	my -= pos.y;
	switch (event)
	{
		case MOUSE_DOWN:
			control_class.mouse_down(mx, my);
			break;
		case MOUSE_UP:
			control_class.mouse_up(mx, my);
			break;
		case MOUSE_MOVE:
			control_class.mouse_move(mx, my);
			break;
//		case MOUSE_WHEEL:
//			fxlist_mouse_wheel(wheel);
//			break;
	}
}

control_area.prototype.refresh_range_proportions = function(dw, dh)
{
	this.range_proportion = (dw*dh);
	this.range_proportion /= 60*60;
	this.range_proportion = /*Math.sqrt(*/Math.sqrt(this.range_proportion);

	var a;

	for (a = 0; a < this.controls_num; a++)
	{
		if (this.controls[a].type == CONTROL_SLIDER && this.controls[a].flags & CON_FLAG_PROPORTIONAL)
		{
			var mul = api_layers == 2 ? 1 : 0.1;
			this.controls[a].min = this.controls[a].min_orig * mul * this.range_proportion;
			this.controls[a].max = this.controls[a].max_orig * this.range_proportion;
			this.controls[a].value = this.controls[a].value_orig * this.range_proportion;
			this.controls[a].dist = this.controls[a].max - this.controls[a].min;
			if (this.controls[a].value < this.controls[a].min)
				this.controls[a].value = this.controls[a].min;
			if (this.controls[a].value > this.controls[a].max)
				this.controls[a].value = this.controls[a].max;
		}
	}
}

control_area.prototype.register_controls = function(canvas_in, UI_change_callback)
{
	this.canvas = canvas_in;

	page_mouse_callback_register(this.mouse)

	this.area_wid = canvas_in.width;
	this.area_hei = canvas_in.height;

	this.UI_change = UI_change_callback;
}

control_area.prototype.register_eval_callback = function(UI_change_eval_callback)
{
	this.UI_change_eval = UI_change_eval_callback;
}

control_area.prototype.paint_refresh = function()
{
	var a;
	var con;
	var x, y, w;
	var grad;

	if (!this.context) return;
	rect(this.context, 0, 0, this.canvas.width, this.canvas.height, FILL, this.col_bg, 1);

	for (a = 0; a < this.controls_num; a++)
	{
		con = this.controls[a];
		if (!con.visible) continue;

		x = this.offset_x + con.pos_x;
		y = this.offset_y + con.pos_y;

		switch (con.type)
		{
			case CONTROL_SLIDER:
				draw_text(this.context, x, y - 10, con.display_name, UI_FONT, this.col_text, 1);
				if (con.col_grad_m != 0)
					grad = create_gradient3(this.context, LINEAR, x, y, x + (CONTROL_SLIDER_WID - 1)/2, y, x + CONTROL_SLIDER_WID - 1, y, con.col_grad_s, con.col_grad_m, con.col_grad_e);
				else
					grad = create_gradient(this.context, LINEAR, x, y, x + CONTROL_SLIDER_WID - 1, y, con.col_grad_s, con.col_grad_e);
				rect_round(this.context, x, y, CONTROL_SLIDER_WID, CONTROL_SLIDER_HEI, 3, FILL | GRAD, grad, 1);
				rect_round(this.context, x, y, CONTROL_SLIDER_WID, CONTROL_SLIDER_HEI, 3, OUTLINE, this.col_con, 1);
				break;
			case CONTROL_COLOR:
				draw_text(this.context, x, y, con.display_name, UI_FONT, this.col_text, 1);
				w = measure_text(this.context, con.display_name, UI_FONT);
				rect(this.context, x + 8 + w, y - COLOR_BOX_WIDTH, COLOR_BOX_WIDTH+2, COLOR_BOX_WIDTH+2, FILL, con.value, 1);
				rect(this.context, x + 8 + w, y - COLOR_BOX_WIDTH, COLOR_BOX_WIDTH+2, COLOR_BOX_WIDTH+2, OUTLINE, this.col_con, 1);
				break;
			case CONTROL_CHECKBOX:
				draw_text(this.context, x, y, con.display_name, UI_FONT, this.col_text, 1);
				w = measure_text(this.context, con.display_name, UI_FONT);
				rect(this.context, x + 8 + w, y - COLOR_BOX_WIDTH, COLOR_BOX_WIDTH+2, COLOR_BOX_WIDTH+2, FILL, this.col_bg, 1);
				rect(this.context, x + 8 + w, y - COLOR_BOX_WIDTH, COLOR_BOX_WIDTH+2, COLOR_BOX_WIDTH+2, OUTLINE, this.col_con, 1);
				break;
			case CONTROL_BUTTON:
				this.context.globalAlpha = 1;
				if (img_bt_rst_ok)				
					this.context.drawImage(con.image, x, y-30);
			/*
				w = measure_text(this.context, con.display_name, UI_FONT) + CONTROL_BUTTON_HOR_MARGIN*2;
				rect(this.context, x-1, y - CONTROL_BUTTON_HEIGHT+2, w+2, CONTROL_BUTTON_HEIGHT+2, FILL, this.col_bg, 1);
				draw_text(this.context, x + CONTROL_BUTTON_HOR_MARGIN, y, con.display_name, UI_FONT, this.col_text, 1);
				rect_round(this.context, x, y - CONTROL_BUTTON_HEIGHT+3, w, CONTROL_BUTTON_HEIGHT, 3, OUTLINE, this.col_con, 1);
			*/
				break;
		}
	}

	this.paint_update(1);
}

control_area.prototype.paint_start = function(context_in, ox, oy)
{
	this.offset_x = ox;
	this.offset_y = oy;
	this.context = context_in;

	this.paint_refresh();
}

control_area.prototype.paint_update = function(force)
{
	var a;
	var con;
	var x, y, p, pp;

	for (a = 0; a < this.controls_num; a++)
	{
		con = this.controls[a];
		if (!con.visible) continue;

		x = this.offset_x + con.pos_x;
		y = this.offset_y + con.pos_y;
		switch (con.type)
		{

			case CONTROL_SLIDER:

				if (con.value != con.value_last_pos || force)
				{
					p = x + ((con.value - con.min) * CONTROL_SLIDER_WID) / con.dist;
					if (con.value_last_pos != -1)
					{
						pp = con.value_last_pos;
						rect(this.context, pp - ARROW_WIDTH, y + CONTROL_SLIDER_HEI + 2, ARROW_WIDTH*2, 8, FILL, this.col_bg, 1);
					}
					triangle(this.context,	p, y + CONTROL_SLIDER_HEI + 2,
										p - ARROW_WIDTH, y + CONTROL_SLIDER_HEI + 8+1,
										p + ARROW_WIDTH, y + CONTROL_SLIDER_HEI + 8+1,
										con.col_arrow, 1);
					con.value_last_pos = p;

					if (this.UI_show_values)
					{
						rect(this.context, x + CONTROL_SLIDER_WID - 64, y - 8 - 15, 128, 15, FILL, col_white, 1);
						draw_text(this.context, x + CONTROL_SLIDER_WID - 64, y - 8, con.value.toFixed(2)/*+" "+con.max*/, FONT_ARIAL_15, col_black, 1);
					}
				}

			break;

			case CONTROL_COLOR:
				w = measure_text(this.context, con.display_name, UI_FONT);
				rect(this.context, x + 6 + w, y - COLOR_BOX_WIDTH - 2, COLOR_BOX_WIDTH+2+4, COLOR_BOX_WIDTH+2+4, FILL, this.col_bg, 1);

				rect(this.context, x + 8 + w, y - COLOR_BOX_WIDTH, COLOR_BOX_WIDTH+2, COLOR_BOX_WIDTH+2, FILL, con.value, 1);
				rect(this.context, x + 8 + w, y - COLOR_BOX_WIDTH, COLOR_BOX_WIDTH+2, COLOR_BOX_WIDTH+2, OUTLINE, this.col_con, 1);
			break;

			case CONTROL_CHECKBOX:
				w = measure_text(this.context, con.display_name, UI_FONT);
				x += 8 + w;
				rect(this.context, x - 2, y - COLOR_BOX_WIDTH - 2, COLOR_BOX_WIDTH+2+4, COLOR_BOX_WIDTH+2+4, FILL, this.col_bg, 1);
				rect(this.context, x, y - COLOR_BOX_WIDTH, COLOR_BOX_WIDTH+2, COLOR_BOX_WIDTH+2, OUTLINE, this.col_con, 1);
				if (con.value && con.value_default != -1)
				{
					line(this.context, x, y - COLOR_BOX_WIDTH, x + COLOR_BOX_WIDTH + 1, y + 1, this.col_con, 1, 1);
					line(this.context, x, y + 1, x + COLOR_BOX_WIDTH + 1, y - COLOR_BOX_WIDTH + 1, this.col_con, 1, 1);
				}
				break;

		}
	}
}

// ------------------------------------------------

var UNDO_ITEMS_NUM = 25;

var UNDO_ACTION_VALUE = 0;
var UNDO_ACTION_VALUE_END = 1;
var UNDO_ACTION_FILTER = 2;
var UNDO_ACTION_CANVAS = 3;

var undo_item_pos = -1;

function undo_item()
{
	this.type = this.active = 0;
	this.control = 0;
	this.value = 0;
	this.canvas_wid = this.canvas_hei = 0;
}

var undo_items = new Array();
for (var a = 0; a < UNDO_ITEMS_NUM; a++)
	undo_items.push(new undo_item());

function undo_add(type, control, value1, value2)
{
	var a;

	if (type == UNDO_ACTION_VALUE_END)
	{
		undo_items[undo_item_pos].active = 0;
		return;
	}
	if (undo_item_pos == UNDO_ITEMS_NUM-1 && !undo_items[undo_item_pos].active)
	{
		undo_items.shift();
		undo_items.push(new undo_item());
		undo_item_pos--;
	}
	var p = undo_item_pos;

	switch (type)
	{
		case UNDO_ACTION_VALUE:
			if (p != -1 && undo_items[p].active) return;
			undo_item_pos++;
			p = undo_item_pos;

			undo_items[p].type = UNDO_ACTION_VALUE;
			undo_items[p].control = control;
			undo_items[p].active = value2;
			undo_items[p].value = value1;
			break;
		case UNDO_ACTION_FILTER:
			undo_item_pos++;
			p = undo_item_pos;

			undo_items[p].type = UNDO_ACTION_FILTER;
			undo_items[p].value = value1;
			undo_items[p].active = 0;
			break;
		case UNDO_ACTION_CANVAS:
			undo_item_pos++;
			p = undo_item_pos;

			undo_items[p].type = UNDO_ACTION_CANVAS;
			undo_items[p].canvas_wid = value1;
			undo_items[p].canvas_hei = value2;
			undo_items[p].active = 0;
			break;
	}
}

function undo_pop()
{
	if (undo_item_pos == -1) return 0;
	var obj = undo_items[undo_item_pos];
	undo_item_pos--;
	return obj;
}

function undo_clear()
{
	undo_item_pos = -1;
}